<script>
	import * as config from '$lib/config';
</script>

<footer class="border-t border-neutral-100">
	<div class="cnt cnt-y-md">
		<div>
			<a href="/">
				<img src="/logo.png" height="27" width="70" alt="Buy Carnival Tyccon Cards logo" />
			</a>

			<div class="text-sm max-w-screen-sm mt-2">
				<p>Not affiliated with Wild Candle Spin LLC</p>
				<p>
					Need help with your order? Check our <a href="/help" class="link">Help Center</a>
				</p>
				<p class="font-medium mt-1">
					Playing Monopoly GO? You can <a class="link text-orange-500" href="https://buymonopolygostickers.com" target="_blank"
						>Buy Monopoly Stickers here</a>
				</p>
			</div>
		</div>
		<ul class="my-4 flex flex-row gap-4 text-sm underline">
			<li><a href="/" class="hover:underline underline-offset-2">Home</a></li>
			<li><a href="/orders" class="hover:underline underline-offset-2">My Orders</a></li>
			<li><a href="/blog" class="hover:underline underline-offset-2">Blog</a></li>
			<li><a href="/help" class="hover:underline underline-offset-2">Help</a></li>
		</ul>

		<div class="flex flex-row gap-2 justify-between text-xs opacity-70 font-medium mt-4">
			<div>© {new Date().getFullYear()} {config.domain.toUpperCase()}</div>
			<div><a href="/privacy">Privacy Policy</a> · <a href="/terms">Terms & Conditions</a></div>
		</div>
	</div>
</footer>
